import { useEffect, useState } from "react";
import { UserAuth } from "../context/AuthContext";

/**
 * Lee el rol institucional del usuario desde los custom claims:
 * role ("escuela" | "maestro") y schoolId (tenant). No falsificable.
 * Devuelve { role, schoolId, loading }.
 */
// Caché por uid: al navegar, el menú (y otros) se remontan; sin caché el rol
// arranca en null y parpadea el menú equivocado antes de resolver el claim.
const roleCache = {};

export function useSchoolRole() {
  const { user } = UserAuth();
  const cached = user && roleCache[user.uid];
  const [state, setState] = useState(
    cached ? { ...cached, loading: false } : { role: null, schoolId: null, loading: true }
  );

  useEffect(() => {
    let active = true;
    (async () => {
      if (!user) {
        if (user === null && active) setState({ role: null, schoolId: null, loading: false });
        return;
      }
      try {
        const res = await user.getIdTokenResult(true);
        const next = { role: res.claims.role || null, schoolId: res.claims.schoolId || null };
        roleCache[user.uid] = next;
        if (active) setState({ ...next, loading: false });
      } catch {
        if (active) setState({ role: null, schoolId: null, loading: false });
      }
    })();
    return () => {
      active = false;
    };
  }, [user]);

  return state;
}
